import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { PopoverController } from "ionic-angular";

/**
 * Generated class for the SelectInputComponent component.
 *c
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: "hidden-input",
  templateUrl: "hidden-input.html",
})
export class HiddenInputComponent implements OnInit {
  // Configuration properties
  @Input() group: FormGroup;
  @Input() config;

  id: string;
  componentId: string;
  label: any;

  constructor(
    public formBuilder: FormBuilder,
    private popover: PopoverController,
    public translatePipe: TranslateService
  ) {}

  ngOnInit(): void {
    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    if (this.label === "false") {
      this.label = false;
    }

    this.group.addControl(this.id, this.formBuilder.control({}));
    this.group.controls[this.id].valueChanges.subscribe((data) => {
      if (data !== undefined) {
      }
    });
    this.group.addControl(this.id, this.formBuilder.control({}));
    this.group.controls[this.id].setValue(this.group.controls[this.id].value);
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/hidden-input/hidden-input.ts